// Decide whether the logged-in user is the PM/PO recorded on a project.
//
// The PM is a person: projects carry pm_id (the person) and po_pm (their
// name, for display). The user is the PM when their linked person
// (team_member_id, from /auth/me) is pm_id. Only a project whose PM was never
// linked to a person falls back to matching po_pm against the user's
// display name or email. The backend enforces the same rule (people.es_pm).

export function isPmOf(user, project) {
  if (!user || !project) return false
  if (project.pm_id != null) return user.team_member_id != null && user.team_member_id === project.pm_id
  const target = String(project.po_pm || '').trim().toLowerCase()
  if (!target) return false
  return [user.display_name, user.email]
    .filter(Boolean)
    .some(s => String(s).trim().toLowerCase() === target)
}

// True if the user is the PM of any project in the given list.
export function isPmOfAny(user, projects) {
  if (!user || !Array.isArray(projects)) return false
  return projects.some(p => isPmOf(user, p))
}
